'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('cb.ui-components.cbModalController', []);

_module.controller('cbModalController', cbModalController);

exports.default = _module;


function cbModalController() {
    var vm = this;

    vm.modal = document.getElementById('cbModal');

    vm.openModal = function () {
        vm.modal.style.display = 'block';
    };

    vm.closeModal = function () {
        vm.modal.style.display = 'none';
    };

    window.onclick = function (event) {
        if (event.target == vm.modal) {
            vm.closeModal();
        }
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/lib/ui-components/modal/cb-modal.controller.js
// module id = 894
// module chunks = 0